module.exports = {
    title: "Commission",
    crud: {
        create: "Create Commission",
        edit: "Edit Commission",
        tableTitle:"History",
    },
    table: {
        currentPercentage: "Percentage",
        currentApplyDate: "Apply Date",
        afterPercentage: "After Percentage",
        afterApplyDate: "After Apply Date",
        isActive: "Status",
        createdAt: "Created Date",
        actions: "Actions",
        columns:{
            currentPercentage:"currentPercentage",
            currentApplyDate:"currentApplyDate",
            afterPercentage:"afterPercentage",
            afterApplyDate:"afterApplyDate",
            isActive:"isActive",
            createdAt:"createdAt",
            actions:"actions",
        }
    },
    form: {
        currentPercentage: "Percentage",
        currentApplyDate: "Apply Date",
        afterPercentage: "After Percentage",
        afterApplyDate: "After Apply Date",
    },
    validation: {
        required: {
            currentPercentage: 'Current percentage is required',
            currentApplyDate: 'Current apply date is required',
        }
    },
}
